/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPoolingHistoryFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type PoolingHistory, type ProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /PoolingHistory/allotment/{allotmentId}
 */
export interface WithAllotmentItemRequestBuilder extends BaseRequestBuilder<WithAllotmentItemRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PoolingHistory[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<PoolingHistory[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithAllotmentItemRequestBuilderUriTemplate = "{+baseurl}/PoolingHistory/allotment/{allotmentId}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithAllotmentItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithAllotmentItemRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createPoolingHistoryFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
